const range = (start, end) => {
    let length = end - start + 1;
    /*
        Create an array of certain length and set the elements within it from
      start value to end value.
    */
    return Array.from({ length }, (_, idx) => idx + start);
};

export const usePagination = ({
    totalCount,
    currentPage,
    siblingCount = 1,
}) => {
    // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
    const totalPageNumbers = siblingCount + 5;

    if (totalPageNumbers >= totalCount) {
        return {
            showLeftDots: false,
            paginationRange: range(2, totalCount - 1),
            showRightDots: false,
        };
    }

    let paginationRange = [];
    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalCount);
    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < totalCount - 2;

    if (!shouldShowLeftDots && shouldShowRightDots) {
        const leftItemCount = 3 + 2 * siblingCount;
        paginationRange = range(2, leftItemCount);
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
        const rightItemCount = 3 + 2 * siblingCount;
        paginationRange = range(
            totalCount - rightItemCount + 1,
            totalCount - 1
        );
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
        paginationRange = range(leftSiblingIndex, rightSiblingIndex);
    }

    return {
        showLeftDots: shouldShowLeftDots,
        paginationRange,
        showRightDots: shouldShowRightDots,
    };
};
